import {Query, gql} from 'apollo-angular';
import { Injectable } from '@angular/core';


import { IProduct } from '@collections/products/interfaces';
import { productFragment } from './fragments/product.fragment';

export interface IProductBySlugResponse {
  productBySlug: IProduct;
}

@Injectable()
export class ProductBySlugGQL extends Query<IProductBySlugResponse> {
  document = gql`
  query getProductBySlug( $companyId: ObjectId!, $lang: String!, $slug: String!){
    productBySlug(companyId: $companyId, lang: $lang, slug: $slug) {
      ...product
      description
      shortDescription
      alternativeLangPath {
        lang
        path
      }
      updatedAt
      minQta
      material
      certifications
      deliveryTime
      dimensions
      packaging
      shipping
      notes
      rating
      ratingCount
    }
  }
  ${productFragment}
  `;
}
/* 
tags(lang: $lang) {
  tag
  slug
  lang
  productsCount
} 
ho dovuto commentarlo sennò non visualizzava e non apriva i prodotti senza tag
*/
